import { useQuery } from "@tanstack/react-query";
import { fetchJanapratinidhis } from "../services/janapratinidhiServices";

export const useFetchJanapratinidhi = () => useQuery({
    queryKey: ['janapratinidhi'],
    queryFn: fetchJanapratinidhis
})
